<app-basic-form [form]="form" [keys]="keys"></app-basic-form>
<div *ngIf="showFunds">
    <app-assets-table [assets]="assets" [form]="form" [tableKeys]="tableKeys" [isReadOnly]="isReadOnly" [shouldWatchAmount]="!arePresetsAvailable"></app-assets-table>
</div>
